import React from 'react';
import QuestionForm from './QuestionForm';
import './QuestionsFormTable.styl';

export default class QuestionsFormTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onChange(index, newQuestion) {
    const {questions} = this.props;
    this.props.onChange(questions.splice(index, 1, newQuestion));
  }

  onDragStart(dragIndex) {
    this.setState({
      dragIndex,
    });
  }

  onDrop(dropIndex) {
    const {questions} = this.props;
    const {dragIndex} = this.state;
    const dragQuestion = questions.get(dragIndex);

    this.props.onChange(questions.remove(dragIndex).insert(dropIndex, dragQuestion));
  }

  onDelete(index) {
    this.props.onChange(this.props.questions.remove(index));
  }

  render() {
    return (
      <table className="questions-form-table generic-table">
        <thead>
          <tr>
            <th className="reorder">Question #</th>
            <th className="word-phrase">Question Text</th>
            <th className="skills">Skills</th>
            <th className="allow-comments">Allow Comments</th>
            <th className="reasons">Preset Reasons</th>
            <th className="delete-question" />
          </tr>
        </thead>
        <tbody>
          {this.props.questions.map((question, i) => (
            <QuestionForm
              inputRef={this.props.inputRef}
              question={question}
              onChange={this.onChange}
              index={i}
              key={i}
              onDragStart={this.onDragStart}
              onDrop={this.onDrop}
              onDelete={this.onDelete}
              showNewReasonSchemeForm={() => this.props.showNewReasonSchemeForm(i)}
              onSearchSkills={this.props.onSearchSkills}
              searchedSkills={this.props.searchedSkills}
              searchTerm={this.props.searchTerm}
            />
          ))}
        </tbody>
      </table>
    );
  }
}
